import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { MenuItem } from '@material-ui/core';
import { departments } from '../../../constants/volunteers';
import { NOT_SELECTED } from '../../../constants/volunteers';

export default function Recommendation(props) {
  const [department, setDepartment] = React.useState(NOT_SELECTED);
  const { open, handleClose } = props;

  return (
    <div>
      <Dialog
        open={open}
        onClose={props.handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Рекомендация</DialogTitle>
        <DialogContent>
          <DialogContentText>
            В какой Отдел Духовного Центра Вы бы хотели рекомендовать кандидата
            <b>{' ' + props.fullName}</b>? После подтверждения рекомендации
            анкета данного кандида будет авторматически отправлена на
            электронную почту руководителю Отдела.
          </DialogContentText>
          <TextField
            id="outlined-select-currency"
            select
            fullWidth
            label="Название Отдела"
            value={department}
            onChange={(event) => setDepartment(event.target.value)}
            variant="outlined"
          >
            {departments.map((option) => (
              <MenuItem key={option.id} value={option.id}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">
            Отменить
          </Button>
          <Button onClick={handleClose} color="primary">
            Рекомендовать
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
